export enum PlanTypeApiUrls {
    GetPlanTypes ='/api/PlanType/GetPlanTypes',
  }
